'use client';

import React, { useState } from 'react';
import { Button } from 'atoms/Button';
import { Chips } from 'organisms/Filters/Chips';
import { FilterItem } from 'organisms/Filters/FilterItem';
import { useFilters } from 'organisms/Filters/hooks';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IFilter } from 'commerce/factFinder/types';
import styles from './styles.module.css';

export const BrandsFilter = ({ brands }: { brands: IFilter[] }) => {
  const t = useTranslations();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const { filters, handleReset, handleSearch } = useFilters();

  const brandsMap = brands.reduce(
    (acc, brand) => {
      return {
        ...acc,
        [String(brand.value)]: brand.displayValue,
      };
    },
    {} as Record<string, string | undefined>,
  );

  return (
    <div>
      <div className={styles.brandsFilter}>
        <FilterItem
          label={t('search.filters.brand')}
          value={
            !!filters?.length
              ? filters
                  ?.map((brand) => brandsMap[String(brand.value)])
                  .join(', ')
              : t('search.filters.all')
          }
          isActive={isFilterOpen}
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className={styles.filter}
        />
        <Button
          className={styles.submit}
          onClick={() => {
            handleSearch();
            setIsFilterOpen(false);
          }}
        >
          {t('search.filters.apply')}
        </Button>
        <Button
          className={styles.reset}
          onClick={() => {
            handleReset();
            setIsFilterOpen(false);
          }}
        >
          {t('search.filters.reset')}
        </Button>
      </div>
      <Chips list={brands} isVisible={isFilterOpen} />
    </div>
  );
};
